import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

// import { useSelector } from "react-redux";

import config from "../../../config";
import { Footer } from "../../../layouts";
import { HeroSm, NavBar, Spinner } from "../../../components";
import { Slang } from "../../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { BsCheckCircle, BsX } from "react-icons/bs";
import { Link } from "react-router-dom";
import { clearCart } from "../../../store/cart.slice";

const PaymentVerification = () => {
  const token = useSelector((state) => state.auth.token.value);
  // console.log(tokenPayment, payerId);
  const dispatch = useDispatch();

  const [paymentStatus, setPaymentStatus] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const fetchPaymentStatus = async () => {
    const bodyString = localStorage.getItem("paymentInfos");
    const body = JSON.parse(bodyString);
    console.log(body);

    try {
      const response = await axios.post(
        `${config.apiUrl}/verify/payment`,
        {
          orderIds: body.orderIds,
          paymentId: body.paymentId,
          payment_method: body.paymentMethod,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        setPaymentStatus(response.data.status);
        setShowResult(true);
      }
    } catch (error) {
      console.error(error);
      setPaymentStatus("Error fetching payment status");
      // setShowResult(true);
    }
  };

  useEffect(() => {
    fetchPaymentStatus();
  }, []);

  useEffect(() => {
    if (paymentStatus === "success" || showResult) {
      dispatch(clearCart());
    }
  }, [paymentStatus, showResult, dispatch]);

  const lang = Slang("navbar");

  return (
    <>
      <NavBar />
      <HeroSm title={lang("t7")} />
      <div className="container my-10 py-5 text-center">
        {paymentStatus === null || !showResult ? (
          <div className=" d-flex justify-content-center align-items-center">
            {" "}
            <Spinner size={3} />{" "}
            <h4 className=" ms-2 mt-2 fw-normal">Loading payment status...</h4>{" "}
          </div>
        ) : (
          <div
            className={`transition-opacity duration-500 ${
              showResult ? "opacity-100" : "opacity-0"
            }`}
          >
            {paymentStatus === "success" ? (
              <>
                <div className="d-flex justify-content-center align-items-center mb-5">
                  <BsCheckCircle
                    size={60}
                    className=" text-success"
                  ></BsCheckCircle>{" "}
                  <h2 className=" ms-2 mt-2 fw-normal text-success ">
                    Your Payment is Successful.
                  </h2>
                </div>
                <Link to="/market-place">
                  <button className="btn btn-sm btn-primary">
                    {" "}
                    Back to shop{" "}
                  </button>
                </Link>
              </>
            ) : (
              <>
                <div className="d-flex justify-content-center align-items-center mb-5">
                  <BsX size={60} color={"red"}></BsX>{" "}
                  <h2 className=" ms-2 mt-2 fw-normal text-danger">
                    Payment Failed !!!{" "}
                  </h2>
                </div>
                <Link to="/market-place/cart">
                  <button className="btn btn-sm btn-primary">
                    {" "}
                    Try again{" "}
                  </button>
                </Link>
              </>
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default PaymentVerification;
